import { OrderItemModel } from "../../../../../../core/ek-e-commerce/ek-models/OrderItem.model";
import { FolderModel } from "../../../../../../core/ek-e-commerce/ek-models/folder.model";
import { StocksService } from "../../../../../../core/ek-e-commerce/ek-services/stocks.service";
import { CreditModel } from "../../../../../../core/ek-e-commerce/ek-models/credit.model";
import { OrderSplitService } from "../../../../../../core/ek-e-commerce/ek-services/order-split.service";
import { OrderSplit } from "../../../../../../core/ek-e-commerce/ek-models/orderSplit";
import { ClientModel } from "../../../../../../core/ek-e-commerce/ek-models/client.model";
import { ocrInfo } from "../../../../../../core/ek-e-commerce/ek-models/document-ocr-information";
import { Component, Input, OnInit } from "@angular/core";
import { DocumentModel } from "../../../../../../core/ek-e-commerce/ek-models/document.model";
import { DocumentService } from "../../../../../../core/services/document.service";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
import { ActivatedRoute } from "@angular/router";
import { BehaviorSubject } from "rxjs";
import { DatePipe, DecimalPipe } from "@angular/common";
import { ProfessionTranslatePipe } from "../../../../../../core/_base/layout/pipes/profession-translate.pipe";
import { EkProductsService } from "../../../../../../core/ek-e-commerce/ek-services/ek-product.service";
import { EkCategoriesService } from "../../../../../../core/ek-e-commerce/ek-services/ek-categories.service";
import { StockModel } from "../../../../../../core/ek-e-commerce/ek-models/stock.model";
import {
  LayoutUtilsService,
  MessageType,
} from "../../../../../../core/_base/crud";

@Component({
  selector: "kt-fourth-step",
  templateUrl: "./fourth-step.component.html",
  styleUrls: ["./fourth-step.component.scss"],
  providers: [DatePipe, ProfessionTranslatePipe, DecimalPipe],
})
export class FourthStepComponent implements OnInit {
  @Input() bankDocuments!: DocumentModel[];
  @Input() information!: ocrInfo;
  @Input() client!: ClientModel;
  @Input() order!: OrderSplit;
  @Input() folder!: FolderModel;

  sitPersoFr = "";
  sitPersoAr = "";
  demandeOuvertureCompteB!: string;
  autorisationDePrelevementBancaire: any;
  autorisationDePrelevement: any;
  demandeDeFinancement: any;
  annexProtectionData: any;
  ficheDeSignature: any;
  engagementDeSolde: any;
  fatca: any;
  autorisationDeConsultation: any;
  folderId!: number;
  orderId!: number;
  image: any;
  credit: CreditModel;
  stocks: StockModel[];

  bankDocuments$ = new BehaviorSubject<DocumentModel[]>(null);

  downLoadFiles$ = new BehaviorSubject<boolean>(false);
  readonly loading$ = this.downLoadFiles$.asObservable();

  currentRole = "";
  categoriess: string[] = [];
  datePrelevement = "";

  constructor(
    private documentService: DocumentService,
    private route: ActivatedRoute,
    private orderSplitService: OrderSplitService,
    private professionTranslatePipe: ProfessionTranslatePipe,
    private productsService: EkProductsService,
    private layoutUtilsService: LayoutUtilsService,
    private categoryService: EkCategoriesService,
    private stocksService: StocksService,
    public datepipe: DatePipe,
    public decimalPipe: DecimalPipe,
  ) {
    this.currentRole = JSON.parse(localStorage.getItem("currentUser")).roles;
  }

  async createPdf() {
    let secondPart;
    this.downLoadFiles$.next(true);

    switch (this.information?.personnelInformation?.socialClientCategory) {
      case "DIVORCE":
        this.sitPersoFr = "Divorcé(e)";
        this.sitPersoAr = "مطلّق(ة)";
        break;
      case "MARRIED":
        this.sitPersoFr = "Marié(e)";
        this.sitPersoAr = "متزوّج(ة)";
        break;
      case "SINGLE":
        this.sitPersoFr = "Célibataire";
        this.sitPersoAr = "أعزب / عزباء";
        break;
      case "WIDOWER":
        this.sitPersoFr = "Veuf(ve)";
        this.sitPersoAr = "أرمل / أرملة";
        break;
      default:
        this.sitPersoFr = "";
        this.sitPersoAr = "";
        break;
    }

    // Loading Arabic Font
    const url =
      "https://ekiclik-docs.s3.eu-west-2.amazonaws.com/NotoSansArabic-Black.ttf";
    const fontBytes = await fetch(url).then((res) => res.arrayBuffer());

    // Demande ouverture de compte --------------------------------------------------
    if (this.demandeOuvertureCompteB) {
      const demandeOuvertureCompteB = await fetch(
        this.demandeOuvertureCompteB,
      ).then((res) => res.arrayBuffer());

      const DOCB = await PDFDocument.load(demandeOuvertureCompteB);
      DOCB.registerFontkit(fontkit);
      const arabicFont = await DOCB.embedFont(fontBytes);
      const helveticaFont = await DOCB.embedFont(StandardFonts.HelveticaBold);

      const DOCBpages = DOCB.getPages();
      const DOCBfirstPage = DOCBpages[0];
      const DOCBSecondPage = DOCBpages[1];

      // 1. Récupère les dimensions de la page
      const { width } = DOCBfirstPage.getSize();

      const requestNumber = this.folder?.requestNumber;
      const textWidthX = helveticaFont.widthOfTextAtSize(requestNumber, 14);

      // je soussigné in fr
      DOCBfirstPage.drawText(
        `${
          this.information?.personnelInformation?.firstName +
          " " +
          this.information?.personnelInformation?.lastName
        }`,
        {
          x: 90,
          y: 484,
          size: 8,
          font: helveticaFont,
          color: rgb(0, 0, 0),
        },
      );

      // je soussigné in arabic
      DOCBfirstPage.drawText(
        `${
          this.information?.personnelInformation?.fistNameEnArab +
          " " +
          this.information?.personnelInformation?.lastNameEnArab
        }`,
        {
          x: this.getX(
            500,
            this.information?.personnelInformation?.fistNameEnArab
              ? this.invertNumbers(
                  this.information?.personnelInformation?.fistNameEnArab,
                )
              : "",
            arabicFont,
            12,
          ),
          y: 482,
          size: 8,
          font: arabicFont,
          color: rgb(0, 0, 0),
        },
      );

      // name in fr
      DOCBfirstPage.drawText(
        `${
          this.information?.personnelInformation?.firstName +
          " " +
          this.information?.personnelInformation?.lastName
        }`,
        {
          x: 100,
          y: 425,
          size: 8,
          font: helveticaFont,
          color: rgb(0, 0, 0),
        },
      );

      // name in arabic
      DOCBfirstPage.drawText(
        `${
          this.information?.personnelInformation?.fistNameEnArab +
          " " +
          this.information?.personnelInformation?.lastNameEnArab
        }`,
        {
          x: this.getX(
            500,
            this.information?.personnelInformation?.fistNameEnArab
              ? this.invertNumbers(
                  this.information?.personnelInformation?.fistNameEnArab,
                )
              : "",
            arabicFont,
            12,
          ),
          y: 448,
          size: 8,
          font: arabicFont,
          color: rgb(0, 0, 0),
        },
      );

      // father name fr
      DOCBfirstPage.drawText(
        `${
          this.information?.personnelInformation?.firstNameFather
            ? this.information?.personnelInformation?.firstNameFather
            : ""
        }`,
        {
          x: 95,
          y: 415,
          size: 8,
          font: helveticaFont,
          color: rgb(0, 0, 0),
        },
      );

      // first / last name mother
      DOCBfirstPage.drawText(
        `${
          this.information?.personnelInformation?.lastNameMother
            ? this.information?.personnelInformation?.lastNameMother
            : ""
        } ${" "} ${
          this.information?.personnelInformation?.firstNameMother
            ? this.information?.personnelInformation?.firstNameMother
            : ""
        }`,
        {
          x: 155,
          y: 415,
          size: 8,
          font: helveticaFont,
          color: rgb(0, 0, 0),
        },
      );

      // father name ar
      DOCBfirstPage.drawText(
        `${
          this.information?.personnelInformation?.firstNameFatherInArabic
            ? this.information?.personnelInformation?.firstNameFatherInArabic
            : ""
        }`,
        {
          x: this.getX(
            530,
            this.information?.personnelInformation?.firstNameFatherInArabic
              ? this.invertNumbers(
                  this.information?.personnelInformation
                    ?.firstNameFatherInArabic,
                )
              : "",
            arabicFont,
            8,
          ),
          y: 415,
          size: 8,
          font: arabicFont,
          color: rgb(0, 0, 0),
        },
      );

      // mother name ar
      DOCBfirstPage.drawText(
        `${
          this.information?.personnelInformation?.lastNameMotherInArabic
            ? this.information?.personnelInformation?.lastNameMotherInArabic
            : ""
        } ${" "} ${
          this.information?.personnelInformation?.firstNameMotherInArabic
            ? this.information?.personnelInformation?.firstNameMotherInArabic
            : ""
        }`,
        {
          x: this.getX(
            460,
            this.information?.personnelInformation?.lastNameMotherInArabic
              ? this.invertNumbers(
                  this.information?.personnelInformation
                    ?.lastNameMotherInArabic,
                )
              : "",
            arabicFont,
            8,
          ),
          y: 415,
          size: 8,
          font: arabicFont,
          color: rgb(0, 0, 0),
        },
      );

      // birthdate / placeOfBirth fr
      DOCBfirstPage.drawText(
        `${
          this.information?.personnelInformation?.birthDay
            ? this.information?.personnelInformation?.birthDay
            : ""
        } ${" à "} ${
          this.information?.personnelInformation?.placeOfBirth
            ? this.information?.personnelInformation?.placeOfBirth
            : ""
        }`,
        {
          x: 143,
          y: 406,
          size: 8,
          font: helveticaFont,
          color: rgb(0, 0, 0),
        },
      );

      // birthdate arab
      DOCBfirstPage.drawText(
        `${
          this.information?.personnelInformation?.birthDay
            ? " " + this.information?.personnelInformation?.birthDay + " "
            : ""
        }`,
        {
          x: 480,
          y: 404,
          size: 8,
          font: helveticaFont,
          color: rgb(0, 0, 0),
        },
      );

      // place Of Brith arab
      DOCBfirstPage.drawText(
        `${" بـ "} ${
          this.information?.personnelInformation?.placeOfBrithArabic
            ? this.information?.personnelInformation?.placeOfBrithArabic
            : ""
        }`,
        {
          x: 420,
          y: 404,
          size: 8,
          font: arabicFont,
          color: rgb(0, 0, 0),
        },
      );

      // sitaution perso en fr
      DOCBfirstPage.drawText(`${this.sitPersoFr ? this.sitPersoFr : ""}`, {
        x: 120,
        y: 396,
        size: 8,
        font: helveticaFont,
        color: rgb(0, 0, 0),
      });

      // sitaution perso en ar
      DOCBfirstPage.drawText(`${this.sitPersoAr ? this.sitPersoAr : ""}`, {
        x: 480,
        y: 392,
        size: 8,
        font: arabicFont,
        color: rgb(0, 0, 0),
      });

      // number of children fr
      DOCBfirstPage.drawText(
        `${
          this.information?.personnelSituation?.dependentChild
            ? this.information?.personnelSituation?.dependentChild
            : 0
        }`,
        {
          x: 160,
          y: 386,
          size: 8,
          font: helveticaFont,
          color: rgb(0, 0, 0),
        },
      );

      // number of children ar
      DOCBfirstPage.drawText(
        `${
          this.information?.personnelSituation?.dependentChild
            ? this.information?.personnelSituation?.dependentChild
            : 0
        }`,
        {
          x: 450,
          y: 382,
          size: 8,
          font: helveticaFont,
          color: rgb(0, 0, 0),
        },
      );

      // profession
      DOCBfirstPage.drawText(
        `${
          this.information?.professionalSituation?.profession
            ? this.professionTranslatePipe.transform(
                this.information?.professionalSituation?.profession,
              )
            : ""
        }`,
        {
          x: 110,
          y: 376,
          size: 8,
          font: helveticaFont,
          color: rgb(0, 0, 0),
        },
      );

      // employer Address
      DOCBfirstPage.drawText(
        `${
          ", " + this.information?.professionalSituation?.employerAddress
            ? this.information?.professionalSituation?.employerAddress
            : ""
        }     `,
        {
          x: 120,
          y: 365,
          size: 8,
          font: helveticaFont,
          color: rgb(0, 0, 0),
        },
      );

      // address fr
      DOCBfirstPage.drawText(
        `${
          this.information?.personnelSituation?.personnelSituationAddressAscii
            ? this.information?.personnelSituation
                ?.personnelSituationAddressAscii
            : ""
        }     `,
        {
          x: 80,
          y: 345,
          size: 8,
          font: helveticaFont,
          color: rgb(0, 0, 0),
        },
      );

      // address ar
      const originalAddress = this.reverseDigitsInText(
        this.information?.personnelSituation?.personnelSituationAddress ?? "",
      );

      const fontSize = 8;
      const pageWidth = DOCBfirstPage.getWidth();
      const rightMargin = 50;

      const textWidth = arabicFont.widthOfTextAtSize(originalAddress, fontSize);
      x = pageWidth - rightMargin - textWidth;

      DOCBfirstPage.drawText(originalAddress, {
        x,
        y: 332,
        size: fontSize,
        font: arabicFont,
        color: rgb(0, 0, 0),
      });

      // phone fr
      DOCBfirstPage.drawText(`${this.order?.phone ? this.order?.phone : ""}`, {
        x: 90,
        y: 201,
        size: 8,
        font: helveticaFont,
        color: rgb(0, 0, 0),
      });

      // email fr
      DOCBfirstPage.drawText(`${this.client ? this.client?.email : ""}`, {
        x: 90,
        y: 181,
        size: 8,
        font: helveticaFont,
        color: rgb(0, 0, 0),
      });

      // salaire net fr
      DOCBfirstPage.drawText(
        `${this.order?.salarySimulation ? this.order?.salarySimulation : ""} DZD`,
        {
          x: 125,
          y: 172,
          size: 8,
          font: helveticaFont,
          color: rgb(0, 0, 0),
        },
      );

      // phone ar
      DOCBfirstPage.drawText(`${this.order?.phone ? this.order?.phone : ""}`, {
        x: 450,
        y: 192,
        size: 8,
        font: helveticaFont,
        color: rgb(0, 0, 0),
      });

      // email ar
      DOCBfirstPage.drawText(`${this.client ? this.client?.email : ""}`, {
        x: 395,
        y: 166,
        size: 8,
        font: helveticaFont,
        color: rgb(0, 0, 0),
      });

      // salary ar
      DOCBfirstPage.drawText(
        `${this.order?.salarySimulation ? this.order?.salarySimulation : ""} `,
        {
          x: 460,
          y: 154,
          size: 8,
          font: helveticaFont,
          color: rgb(0, 0, 0),
        },
      );

      // salary currancy ar
      // Estimation largeur par chiffre (en pixels)
      const digitCount = this.order?.salarySimulation?.toString().length || 0;
      const estimatedTextWidth = digitCount * 2; // 4 est une estimation moyenne pour font size 8

      // Position de la devise 'دج' légèrement à gauche du chiffre
      DOCBfirstPage.drawText("دج", {
        x: 460 - estimatedTextWidth - 5, // '-5' pour espacement entre le nombre et la devise
        y: 154,
        size: 7,
        font: arabicFont,
        color: rgb(0, 0, 0),
      });

      // lieu de signature
      DOCBSecondPage.drawText(
        `${this.order.pointOfSaleTo?.posCommune ? this.order.pointOfSaleTo?.posCommune : ""}`,
        {
          x: 130,
          y: 425,
          size: 10,
          font: helveticaFont,
          color: rgb(0, 0, 0),
        },
      );

      // date de signature
      DOCBSecondPage.drawText(
        `${this.order.createdAt ? this.datepipe.transform(new Date(this.order.createdAt), "dd/MM/yyyy") : ""}`,
        {
          x: 220,
          y: 425,
          size: 10,
          font: helveticaFont,
          color: rgb(0, 0, 0),
        },
      );

      x = (width - textWidthX) / 2;

      // requestNumber page 1
      DOCBfirstPage.drawText(
        `${this.folder?.requestNumber ? this.folder?.requestNumber : ""}`,
        {
          x: x,
          y: 800,
          size: 14,
          font: helveticaFont,
          color: rgb(0, 0, 0),
        },
      );

      // requestNumber page 2
      DOCBSecondPage.drawText(
        this.folder?.requestNumber ? this.folder?.requestNumber : "",
        {
          x: x,
          y: 800,
          size: 14,
          font: helveticaFont,
          color: rgb(0, 0, 0),
        },
      );

      //Demande ouverture de compte
      const pdfBytes1 = await DOCB.save();
      this.saveByteArray(
        `Demande ouverture de compte - ${this.folder?.requestNumber ? this.folder?.requestNumber : ""}.pdf`,
        pdfBytes1,
      );
    }

    // Autorisation de prelevement
    if (this.order?.accountType === "CCP" && this.autorisationDePrelevement) {
      const autorisationDePrelevement = await fetch(
        this.autorisationDePrelevement,
      ).then((res) => res.arrayBuffer());

      const ADP = await PDFDocument.load(autorisationDePrelevement);
      ADP.registerFontkit(fontkit);
      const arabicFont2 = await ADP.embedFont(fontBytes);
      const helveticaFont2 = await ADP.embedFont(StandardFonts.HelveticaBold);

      const ADPpages = ADP.getPages();
      const ADPfirstPage = ADPpages[0];

      ADPfirstPage.drawText(
        `${this.folder?.requestNumber ? this.folder?.requestNumber : ""}`,
        {
          x: 250,
          y: 577.5,
          size: 12,
          font: helveticaFont2,
          color: rgb(0, 0, 0),
        },
      );

      var x = 115;
      if (this.information?.personnelInformation?.firstName) {
        for (
          var i = 0;
          i < this.information?.personnelInformation?.firstName!.length;
          i++
        ) {
          ADPfirstPage.drawText(
            `${this.information?.personnelInformation?.firstName!.charAt(i)}`,
            {
              x: x,
              y: 425,
              size: 18,
              font: helveticaFont2,
              color: rgb(0, 0, 0),
            },
          );
          x = x + 21;
        }
      }
      x = 115;
      if (this.information?.personnelInformation?.lastName) {
        for (
          var i = 0;
          i < this.information?.personnelInformation?.lastName!.length;
          i++
        ) {
          ADPfirstPage.drawText(
            `${this.information?.personnelInformation?.lastName!.charAt(i)}`,
            {
              x: x,
              y: 460,
              size: 18,
              font: helveticaFont2,
              color: rgb(0, 0, 0),
            },
          );
          x = x + 21;
        }
      }
      x = 115;
      if (this.information?.financialSituation?.accountNumber) {
        for (
          var i = 0;
          i <
          String(this.information?.financialSituation?.accountNumber).length;
          i++
        ) {
          ADPfirstPage.drawText(
            `${String(
              this.information?.financialSituation?.accountNumber,
            ).charAt(i)}`,
            {
              x: x,
              y: 390,
              size: 18,
              font: helveticaFont2,
              color: rgb(0, 0, 0),
            },
          );
          x = x + 21;
        }
      }

      let bankAccountNumber = "391779";
      let bankAccountKey = "19";
      x = 115;

      if (bankAccountNumber) {
        for (var i = 0; i < bankAccountNumber.length; i++) {
          ADPfirstPage.drawText(`${bankAccountNumber.charAt(i)}`, {
            x: x,
            y: 352,
            size: 18,
            font: helveticaFont2,
            color: rgb(0, 0, 0),
          });
          x = x + 21;
        }
      }
      x = 335;
      if (this.information?.financialSituation?.accountKey) {
        for (
          var i = 0;
          i < String(this.information?.financialSituation?.accountKey!).length;
          i++
        ) {
          ADPfirstPage.drawText(
            `${String(this.information?.financialSituation?.accountKey)!.charAt(
              i,
            )}`,
            {
              x: x,
              y: 390,
              size: 18,
              font: helveticaFont2,
              color: rgb(0, 0, 0),
            },
          );
          x = x + 21;
        }
      }
      x = 335;
      if (bankAccountKey) {
        for (var i = 0; i < bankAccountKey.length; i++) {
          ADPfirstPage.drawText(`${bankAccountKey.charAt(i)}`, {
            x: x,
            y: 352,
            size: 18,
            font: helveticaFont2,
            color: rgb(0, 0, 0),
          });
          x = x + 21;
        }
      }

      x = 115;
      if (this.datePrelevement ? this.datePrelevement : "") {
        for (var i = 0; i < this.datePrelevement.length; i++) {
          ADPfirstPage.drawText(`${this.datePrelevement!.charAt(i)}`, {
            x: x,
            y: 278.7,
            size: 18,
            font: helveticaFont2,
            color: rgb(0, 0, 0),
          });
          x = x + 21;
        }
      }

      x = 115;
      if (this.credit?.monthlyPayment) {
        const monthlyPayment: number = this.credit.monthlyPayment + 100;
        for (
          var i = 0;
          i < String(this.formatNumber(monthlyPayment)).length;
          i++
        ) {
          ADPfirstPage.drawText(
            `${String(this.formatNumber(monthlyPayment))!.charAt(i)}`,
            {
              x: x,
              y: 246.5,
              size: 18,
              font: helveticaFont2,
              color: rgb(0, 0, 0),
            },
          );
          x = x + 21;
        }
      }

      x = 115;
      if (this.credit?.numberOfMonths) {
        const numMonths: string = String(this.credit.numberOfMonths - 1);
        for (var i = 0; i < numMonths.length; i++) {
          ADPfirstPage.drawText(`${numMonths!.charAt(i)}`, {
            x: x,
            y: 212,
            size: 18,
            font: helveticaFont2,
            color: rgb(0, 0, 0),
          });
          x = x + 21;
        }
      }

      x = 520;
      if (this.information?.personnelInformation?.firstName) {
        for (
          var i = 0;
          i < this.information?.personnelInformation?.firstName!.length;
          i++
        ) {
          ADPfirstPage.drawText(
            `${this.information?.personnelInformation?.firstName!.charAt(i)}`,
            {
              x: x,
              y: 457,
              size: 18,
              font: helveticaFont2,
              color: rgb(0, 0, 0),
            },
          );
          x = x + 21;
        }
      }
      x = 520;
      if (this.information?.personnelInformation?.lastName) {
        for (
          var i = 0;
          i < this.information?.personnelInformation?.lastName!.length;
          i++
        ) {
          ADPfirstPage.drawText(
            `${this.information?.personnelInformation?.lastName!.charAt(i)}`,
            {
              x: x,
              y: 492,
              size: 18,
              font: helveticaFont2,
              color: rgb(0, 0, 0),
            },
          );
          x = x + 21;
        }
      }
      x = 520;
      if (this.information?.financialSituation?.accountNumber) {
        for (
          var i = 0;
          i <
          String(this.information?.financialSituation?.accountNumber!).length;
          i++
        ) {
          ADPfirstPage.drawText(
            `${String(
              this.information?.financialSituation?.accountNumber,
            )!.charAt(i)}`,
            {
              x: x,
              y: 422,
              size: 18,
              font: helveticaFont2,
              color: rgb(0, 0, 0),
            },
          );
          x = x + 21;
        }
      }
      x = 520;
      if (bankAccountNumber) {
        for (var i = 0; i < bankAccountNumber.length; i++) {
          ADPfirstPage.drawText(`${bankAccountNumber.charAt(i)}`, {
            x: x,
            y: 383,
            size: 18,
            font: helveticaFont2,
            color: rgb(0, 0, 0),
          });
          x = x + 21;
        }
      }
      x = 740;
      if (this.information?.financialSituation?.accountKey) {
        for (
          var i = 0;
          i < String(this.information?.financialSituation?.accountKey!).length;
          i++
        ) {
          ADPfirstPage.drawText(
            `${String(this.information?.financialSituation?.accountKey)!.charAt(
              i,
            )}`,
            {
              x: x,
              y: 422,
              size: 18,
              font: helveticaFont2,
              color: rgb(0, 0, 0),
            },
          );
          x = x + 21;
        }
      }
      x = 740;
      if (bankAccountKey) {
        for (var i = 0; i < bankAccountKey.length; i++) {
          ADPfirstPage.drawText(`${bankAccountKey.charAt(i)}`, {
            x: x,
            y: 383,
            size: 18,
            font: helveticaFont2,
            color: rgb(0, 0, 0),
          });
          x = x + 21;
        }
      }

      x = 520;
      if (this.datePrelevement ? this.datePrelevement : "") {
        for (var i = 0; i < this.datePrelevement.length; i++) {
          ADPfirstPage.drawText(`${this.datePrelevement!.charAt(i)}`, {
            x: x,
            y: 310.5,
            size: 18,
            font: helveticaFont2,
            color: rgb(0, 0, 0),
          });
          x = x + 21;
        }
      }

      x = 520;
      if (this.credit?.monthlyPayment) {
        const monthlyPayment: number = this.credit.monthlyPayment + 100;
        for (
          var i = 0;
          i < String(this.formatNumber(monthlyPayment)).length;
          i++
        ) {
          ADPfirstPage.drawText(
            `${String(this.formatNumber(monthlyPayment))!.charAt(i)}`,
            {
              x: x,
              y: 277.3,
              size: 18,
              font: helveticaFont2,
              color: rgb(0, 0, 0),
            },
          );
          x = x + 21;
        }
      }

      x = 520;
      if (this.credit?.numberOfMonths) {
        const numMonths: string = String(this.credit.numberOfMonths - 1);
        for (var i = 0; i < numMonths.length; i++) {
          ADPfirstPage.drawText(`${numMonths!.charAt(i)}`, {
            x: x,
            y: 244.5,
            size: 18,
            font: helveticaFont2,
            color: rgb(0, 0, 0),
          });
          x = x + 21;
        }
      }

      ADPfirstPage.drawText(
        `${this.order.pointOfSaleTo?.posCommune ? this.order.pointOfSaleTo?.posCommune : ""}`,
        {
          x: 295,
          y: 198,
          size: 10,
          font: helveticaFont2,
          color: rgb(0, 0, 0),
        },
      );

      ADPfirstPage.drawText(
        `${this.order.createdAt ? this.datepipe.transform(new Date(this.order.createdAt), "dd/MM/yyyy") : ""}`,
        {
          x: 355,
          y: 198,
          size: 10,
          font: helveticaFont2,
          color: rgb(0, 0, 0),
        },
      );

      ADPfirstPage.drawText(
        `${this.order.pointOfSaleTo?.posCommune ? this.order.pointOfSaleTo?.posCommune : ""}`,
        {
          x: 685,
          y: 92,
          size: 10,
          font: helveticaFont2,
          color: rgb(0, 0, 0),
        },
      );

      ADPfirstPage.drawText(
        `${this.order.createdAt ? this.datepipe.transform(new Date(this.order.createdAt), "dd/MM/yyyy") : ""}`,
        {
          x: 745,
          y: 92,
          size: 10,
          font: helveticaFont2,
          color: rgb(0, 0, 0),
        },
      );

      const pdfBytes2 = await ADP.save();
      this.saveByteArray(
        `Autorisation de prélèvement - ${this.folder?.requestNumber ? this.folder?.requestNumber : ""}.pdf`,
        pdfBytes2,
      );
    }

    // Autorisation de prelevement bancaire
    if (
      (this.order?.accountType === "BANK" ||
        this.order?.accountType === "BANKASBA") &&
      this.autorisationDePrelevementBancaire
    ) {
      const autorisationDePrelevementBancaire = await fetch(
        this.autorisationDePrelevementBancaire,
      ).then((res) => res.arrayBuffer());

      const ADPB = await PDFDocument.load(autorisationDePrelevementBancaire);
      ADPB.registerFontkit(fontkit);

      const helveticaFont8 = await ADPB.embedFont(StandardFonts.HelveticaBold);

      const ADPBPages = ADPB.getPages();
      const ADPBfirstPage = ADPBPages[0];

      ADPBfirstPage.drawText(
        `${
          this.information?.personnelInformation?.firstName
            ? this.information?.personnelInformation?.firstName!
            : ""
        }   ${
          this.information?.personnelInformation?.lastName
            ? this.information?.personnelInformation?.lastName
            : ""
        }`,
        {
          x: 200,
          y: 482,
          size: 10,
          font: helveticaFont8,
          color: rgb(0, 0, 0),
        },
      );

      // address
      ADPBfirstPage.drawText(
        `${this.information?.personnelSituation ? this.information?.personnelSituation?.personnelSituationAddressAscii : ""}`,
        {
          x: 100,
          y: 466,
          size: 9,
          font: helveticaFont8,
          color: rgb(0, 0, 0),
        },
      );

      // email
      ADPBfirstPage.drawText(`${this.client ? this.client?.email : ""}`, {
        x: 100,
        y: 450,
        size: 9,
        font: helveticaFont8,
        color: rgb(0, 0, 0),
      });

      //telephone
      ADPBfirstPage.drawText(`${this.order?.phone ? this.order?.phone : ""}`, {
        x: 100,
        y: 436,
        size: 9,
        font: helveticaFont8,
        color: rgb(0, 0, 0),
      });

      // bank name
      const bankName = this.information?.financialSituation?.bankName
        ? this.information?.financialSituation?.bankName
        : "";
      ADPBfirstPage.drawText(`${bankName}`, {
        x: 160,
        y: 405,
        size: 9,
        font: helveticaFont8,
        color: rgb(0, 0, 0),
      });

      // Agency name
      const agencyName = this.information?.financialSituation?.agencyName
        ? this.information?.financialSituation?.agencyName
        : "";
      ADPBfirstPage.drawText(`${agencyName}`, {
        x: 160,
        y: 390,
        size: 9,
        font: helveticaFont8,
        color: rgb(0, 0, 0),
      });

      // code banque
      let bankCodeX = 108;
      const banqueCode = this.information?.financialSituation?.bankCode
        ? this.information?.financialSituation?.bankCode
        : "";
      if (banqueCode) {
        for (var j = 0; j < String(banqueCode).length; j++) {
          ADPBfirstPage.drawText(`${String(banqueCode).charAt(j)}`, {
            x: bankCodeX,
            y: 353,
            size: 18,
            font: helveticaFont8,
            color: rgb(0, 0, 0),
          });
          bankCodeX = bankCodeX + 21;
        }
      }

      // code banque
      let agencyCodeX = 178;
      const agencyCode = this.information?.financialSituation?.agencyCode
        ? this.information?.financialSituation?.agencyCode
        : "";
      if (agencyCode) {
        for (var j = 0; j < String(agencyCode).length; j++) {
          ADPBfirstPage.drawText(`${String(agencyCode).charAt(j)}`, {
            x: agencyCodeX,
            y: 353,
            size: 18,
            font: helveticaFont8,
            color: rgb(0, 0, 0),
          });
          agencyCodeX = agencyCodeX + 21;
        }
      }

      // account number
      let accountNumberBankX = 292;
      const tempBankAccountNumber =
        this.information?.financialSituation?.accountNumberBank;
      if (tempBankAccountNumber) {
        for (var j = 0; j < String(tempBankAccountNumber).length; j++) {
          ADPBfirstPage.drawText(`${String(tempBankAccountNumber).charAt(j)}`, {
            x: accountNumberBankX,
            y: 353,
            size: 18,
            font: helveticaFont8,
            color: rgb(0, 0, 0),
          });
          accountNumberBankX = accountNumberBankX + 21;
        }
      }

      let accountKeyX = 502;
      if (this.information?.financialSituation?.accountKey) {
        for (
          var j = 0;
          j < String(this.information?.financialSituation?.accountKey!).length;
          j++
        ) {
          ADPBfirstPage.drawText(
            `${String(this.information?.financialSituation?.accountKey)!.charAt(
              j,
            )}`,
            {
              x: accountKeyX,
              y: 353,
              size: 18,
              font: helveticaFont8,
              color: rgb(0, 0, 0),
            },
          );
          accountKeyX = accountKeyX + 21;
        }
      }

      // monthlyPayment
      ADPBfirstPage.drawText(
        `${this.credit?.monthlyPayment ? this.decimalPipe.transform(this.credit?.monthlyPayment + 200, "1.2-2") : ""}`,
        {
          x: 120,
          y: 248,
          size: 10,
          font: helveticaFont8,
          color: rgb(0, 0, 0),
        },
      );

      // number of months
      ADPBfirstPage.drawText(
        `${this.credit?.numberOfMonths ? this.credit?.numberOfMonths : ""}`,
        {
          x: 400,
          y: 248,
          size: 10,
          font: helveticaFont8,
          color: rgb(0, 0, 0),
        },
      );

      // fait le ...
      ADPBfirstPage.drawText(
        `${this.order.pointOfSaleTo?.posCommune ? this.order.pointOfSaleTo?.posCommune : ""}`,
        {
          x: 90,
          y: 160,
          size: 10,
          font: helveticaFont8,
          color: rgb(0, 0, 0),
        },
      );

      ADPBfirstPage.drawText(
        `${this.order.createdAt ? this.datepipe.transform(new Date(this.order.createdAt), "dd/MM/yyyy") : ""}`,
        {
          x: 180,
          y: 160,
          size: 10,
          font: helveticaFont8,
          color: rgb(0, 0, 0),
        },
      );

      // Autorisation de prélèvement bancaire
      const pdfBytes8 = await ADPB.save();
      this.saveByteArray(
        `Autorisation de prélèvement bancaire- ${this.folder?.requestNumber ? this.folder?.requestNumber : ""}.pdf`,
        pdfBytes8,
      );
    }

    // Demande de financement
    if (this.demandeDeFinancement) {
      const demandeDeFinancement = await fetch(this.demandeDeFinancement).then(
        (res) => res.arrayBuffer(),
      );
      const DDF = await PDFDocument.load(demandeDeFinancement);
      DDF.registerFontkit(fontkit);
      const arabicFont3 = await DDF.embedFont(fontBytes);
      const helveticaFont3 = await DDF.embedFont(StandardFonts.HelveticaBold);

      const DDFpages = DDF.getPages();
      const DDFfirstPage = DDFpages[0];
      const DDFsecondPage = DDFpages[1];
      const DDFthirdPage = DDFpages[2];
      const DDFFourthPage = DDFpages[3];
      const DDFFifthPage = DDFpages[4];
      var x = 430;

      // requestNumber
      DDFfirstPage.drawText(
        `${this.folder?.requestNumber ? this.folder?.requestNumber : ""}`,
        {
          x: 35,
          y: 780,
          size: 15,
          font: helveticaFont3,
          color: rgb(0, 0, 0),
        },
      );

      // lastNameEnArab
      DDFfirstPage.drawText(
        `${
          this.information?.personnelInformation?.lastNameEnArab
            ? this.information?.personnelInformation?.lastNameEnArab
            : ""
        }`,
        {
          x: this.getX(
            x,
            this.information?.personnelInformation?.lastNameEnArab!,
            arabicFont3,
            12,
          ),
          y: 630,
          size: 12,
          font: arabicFont3,
          color: rgb(0, 0, 0),
        },
      );

      if (
        this.information?.personnelInformation?.socialClientCategory ===
          "MARRIED" ||
        this.information?.personnelInformation?.socialClientCategory ===
          "WIDOWER"
      ) {
        DDFfirstPage.drawText(
          `${
            this.information?.personnelInformation?.maidenNameInArabic
              ? this.information?.personnelInformation?.maidenNameInArabic
              : ""
          }`,
          {
            x: this.getX(
              x,
              this.information?.personnelInformation?.maidenNameInArabic!,
              arabicFont3,
              12,
            ),
            y: 605,
            size: 12,
            font: arabicFont3,
            color: rgb(0, 0, 0),
          },
        );
      }

      DDFfirstPage.drawText(
        `${
          this.information?.personnelInformation?.fistNameEnArab
            ? this.information?.personnelInformation?.fistNameEnArab
            : ""
        }`,
        {
          x: this.getX(
            x,
            this.information?.personnelInformation?.fistNameEnArab!,
            arabicFont3,
            12,
          ),
          y: 580,
          size: 12,
          font: arabicFont3,
          color: rgb(0, 0, 0),
        },
      );
      DDFfirstPage.drawText(
        `${
          // this.information?.personnelInformation?.birthDay!.length > 12
          //   ? this.datepipe.transform(
          //       this.information?.personnelInformation?.birthDay,
          //       'dd/MM/yyyy'
          //     )
          //   :
          this.information?.personnelInformation?.birthDay
            ? this.information?.personnelInformation?.birthDay
            : ""
        }`,
        {
          x: x - 50,
          y: 552,
          size: 12,
          font: helveticaFont3,
          color: rgb(0, 0, 0),
        },
      );
      var y;
      switch (this.information?.personnelInformation?.socialClientCategory) {
        case "SINGLE": {
          y = 530;
          break;
        }
        case "MARRIED": {
          y = 510;
          break;
        }
        case "DIVORCE": {
          y = 490;
          break;
        }
        case "WIDOWER": {
          y = 470;
        }
      }
      DDFfirstPage.drawText(`X`, {
        x: x - 28,
        y: y,
        size: 15,
        font: helveticaFont3,
        color: rgb(0, 0, 0),
      });

      if (this.information?.personnelSituation?.personnelSituationAddress) {
        const adress = this.invertNumbers(
          this.information?.personnelSituation?.personnelSituationAddress!,
        )!.split(/\s+/);
        var firstPart =
          this.numberTrim(adress[0]) +
          " " +
          this.numberTrim(adress[1]) +
          " " +
          this.numberTrim(adress[2]);
        secondPart = String(adress.slice(3).join(" "));
        if (firstPart.length < 20) {
          firstPart =
            this.numberTrim(adress[0]) +
            " " +
            this.numberTrim(adress[1]) +
            " " +
            this.numberTrim(adress[2]) +
            " " +
            this.numberTrim(adress[3]) +
            " " +
            this.numberTrim(adress[4]);
          secondPart = String(adress.slice(5).join(" "));
        }

        let firstPartArray = firstPart.split(" ");
        firstPart = firstPartArray
          .filter((word) => word !== "undefined")
          .join(" ");
        let secondPartArray = secondPart.split(" ");
        secondPart = secondPartArray
          .filter((word) => word !== "undefined")
          .join(" ");

        DDFfirstPage.drawText(`${firstPart}`, {
          x: this.getX(x + 20, firstPart, arabicFont3, 12),
          y: 450,
          size: 12,
          font: arabicFont3,
          color: rgb(0, 0, 0),
        });
        DDFfirstPage.drawText(`${secondPart}`, {
          x: this.getX(x + 20, secondPart, arabicFont3, 12),
          y: 430,
          size: 12,
          font: arabicFont3,
          color: rgb(0, 0, 0),
        });
      }

      DDFfirstPage.drawText(`${this.order?.phone ? this.order?.phone : ""}`, {
        x: x - 100,
        y: 345,
        size: 12,
        font: helveticaFont3,
        color: rgb(0, 0, 0),
      });

      DDFfirstPage.drawText(`${this.client ? this.client?.email : ""}`, {
        x: this.getX(
          x + 20,
          this.client ? this.client?.email : "",
          helveticaFont3,
          12,
        ),
        y: 313,
        size: 12,
        font: helveticaFont3,
        color: rgb(0, 0, 0),
      });

      DDFfirstPage.drawText(
        `${
          this.information?.personnelSituation?.dependentChild! +
          this.information?.personnelSituation?.dependentOtherPeople!
            ? this.information?.personnelSituation?.dependentChild! +
              this.information?.personnelSituation?.dependentOtherPeople!
            : 0
        }`,
        {
          x: x - 55,
          y: 285,
          size: 12,
          font: arabicFont3,
          color: rgb(0, 0, 0),
        },
      );

      if (this.information?.professionalSituation?.profession) {
        let prof = this.professionTranslatePipe.transform(
          this.information?.professionalSituation?.profession,
        );
        const professionSplited = this.invertNumbers(prof)!.split(/\s+/);
        let firstPart =
          this.numberTrim(professionSplited[0]) +
          " " +
          this.numberTrim(professionSplited[1]) +
          " " +
          this.numberTrim(professionSplited[2]);
        let secondPart = String(professionSplited.slice(3).join(" "));
        if (firstPart.length < 20) {
          firstPart =
            this.numberTrim(professionSplited[0]) +
            " " +
            this.numberTrim(professionSplited[1]) +
            " " +
            this.numberTrim(professionSplited[2]) +
            " " +
            this.numberTrim(professionSplited[3]) +
            " " +
            this.numberTrim(professionSplited[4]);
          secondPart = String(professionSplited.slice(5).join(" "));
        }

        let firstPartArray = firstPart.split(" ");
        firstPart = firstPartArray
          .filter((word) => word !== "undefined")
          .join(" ");
        let secondPartArray = secondPart.split(" ");
        secondPart = secondPartArray
          .filter((word) => word !== "undefined")
          .join(" ");

        DDFfirstPage.drawText(`${firstPart}`, {
          x: this.getX(x + 20, firstPart, helveticaFont3, 12),
          y: 268,
          size: 11,
          font: helveticaFont3,
          color: rgb(0, 0, 0),
        });
        DDFfirstPage.drawText(`${secondPart}`, {
          x: this.getX(x + 20, secondPart, helveticaFont3, 12),
          y: 253,
          size: 11,
          font: helveticaFont3,
          color: rgb(0, 0, 0),
        });
      }

      // DDFfirstPage.drawText(
      //     `${
      //         this.information?.professionalSituation?.profession
      //             ? this.professionTranslatePipe.transform(this.information?.professionalSituation?.profession)
      //             : ''
      //     }`,
      //     {
      //         x: this.getX(
      //             x + 10,
      //             this.information?.professionalSituation?.profession!,
      //             helveticaFont3,
      //             11
      //         ),
      //         y: 255,
      //         size: 11,
      //         font: helveticaFont3,
      //         color: rgb(0, 0, 0),
      //     }
      // );

      DDFfirstPage.drawText(
        `${
          this.information?.professionalSituation?.employer
            ? this.information?.professionalSituation?.employer
            : ""
        }`,
        {
          x: this.getX(
            x + 10,
            this.information?.professionalSituation?.employer!,
            helveticaFont3,
            11,
          ),
          y: 230,
          size: 11,
          font: helveticaFont3,
          color: rgb(0, 0, 0),
        },
      );

      DDFfirstPage.drawText(
        `${
          this.information?.professionalSituation?.employerAddress
            ? this.information?.professionalSituation?.employerAddress
            : ""
        }`,
        {
          x: this.getX(
            x + 10,
            this.information?.professionalSituation?.employerAddress!,
            helveticaFont3,
            11,
          ),
          y: 195,
          size: 11,
          font: helveticaFont3,
          color: rgb(0, 0, 0),
        },
      );

      DDFfirstPage.drawText(
        `${this.order?.salarySimulation ? this.addSeparation(Math.round(100 * this.order?.salarySimulation) / 100) : ""}`,
        {
          x: x - 55,
          y: 95,
          size: 12,
          font: helveticaFont3,
          color: rgb(0, 0, 0),
        },
      );

      DDFfirstPage.drawText(`دج`, {
        x: 320,
        y: 95,
        size: 11,
        font: arabicFont3,
        color: rgb(0, 0, 0),
      });

      DDFsecondPage.drawText(
        `${this.folder?.requestNumber ? this.folder?.requestNumber : ""}`,
        {
          x: 245,
          y: 810,
          size: 12,
          font: helveticaFont3,
          color: rgb(0, 0, 0),
        },
      );

      // Tableau
      // order items less than 16
      if (this.order.orderItems.length < 16) {
        if (this.order.orderItems.length <= 3) {
          let yName = 696;
          let yOthers = 690;

          this.order.orderItems.forEach((item) => {
            let nameSplited = this.capitalizeWords(
              item.configurationTO.name.replace(",", " "),
            ).split(" ");
            let firstLine: string = "";
            let secondLine: string = "";
            let thirdLine: string = "";
            if (
              String(nameSplited.slice(0, 4)).replace(/,/g, " ").length < 28
            ) {
              firstLine = String(nameSplited.slice(0, 7)).replace(/,/g, " ");
              secondLine = String(nameSplited.slice(7, 12)).replace(/,/g, " ");
              thirdLine = String(nameSplited.slice(12)).replace(/,/g, " ");
            } else {
              firstLine = String(nameSplited.slice(0, 6)).replace(/,/g, " ");
              secondLine = String(nameSplited.slice(6, 12)).replace(/,/g, " ");
              thirdLine = String(nameSplited.slice(12)).replace(/,/g, " ");
            }

            DDFthirdPage.drawText(`${firstLine}`, {
              x: 365,
              y: yName,
              size: 8,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            });

            yName = yName - 8;

            DDFthirdPage.drawText(`${secondLine}`, {
              x: 360,
              y: yName,
              size: 8,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            });

            yName = yName - 8;

            DDFthirdPage.drawText(`${thirdLine}`, {
              x: 360,
              y: yName,
              size: 8,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            });

            yName = yName - 5;

            const truncatedConfigPrice =
              Math.trunc((item.sellingPrice / item.quantity) * 100) / 100;
            DDFthirdPage.drawText(
              `${this.addSeparation(truncatedConfigPrice)} DZD`,
              {
                x: 183,
                y: yOthers,
                size: 10,
                font: helveticaFont3,
                color: rgb(0, 0, 0),
              },
            );

            DDFthirdPage.drawText(`${item.quantity}`, {
              x: 140,
              y: yOthers,
              size: 10,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            });

            const truncatedSellingPrice =
              Math.trunc(item.sellingPrice * 100) / 100;
            DDFthirdPage.drawText(
              `${this.addSeparation(truncatedSellingPrice)} DZD`,
              {
                x: 40,
                y: yOthers,
                size: 10,
                font: helveticaFont3,
                color: rgb(0, 0, 0),
              },
            );

            yOthers = yOthers - 21;
          });
        } else {
          let yName = 736;
          let yOthers = 728;

          this.order.orderItems.forEach((item) => {
            let nameSplited = this.capitalizeWords(
              item.configurationTO.name.replace(",", " "),
            ).split(" ");
            let firstLine: string = "";
            let secondLine: string = "";
            let thirdLine: string = "";
            if (
              String(nameSplited.slice(0, 4)).replace(/,/g, " ").length < 28
            ) {
              firstLine = String(nameSplited.slice(0, 7)).replace(/,/g, " ");
              secondLine = String(nameSplited.slice(7, 12)).replace(/,/g, " ");
              thirdLine = String(nameSplited.slice(12)).replace(/,/g, " ");
            } else {
              firstLine = String(nameSplited.slice(0, 6)).replace(/,/g, " ");
              secondLine = String(nameSplited.slice(6, 12)).replace(/,/g, " ");
              thirdLine = String(nameSplited.slice(12)).replace(/,/g, " ");
            }

            DDFthirdPage.drawText(`${firstLine}`, {
              x: 365,
              y: yName,
              size: 8,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            });

            yName = yName - 8;

            DDFthirdPage.drawText(`${secondLine}`, {
              x: 360,
              y: yName,
              size: 8,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            });

            yName = yName - 8;

            DDFthirdPage.drawText(`${thirdLine}`, {
              x: 360,
              y: yName,
              size: 8,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            });

            yName = yName - 5;

            const truncatedConfigPrice =
              Math.trunc((item.sellingPrice / item.quantity) * 100) / 100;
            DDFthirdPage.drawText(
              `${this.addSeparation(truncatedConfigPrice)} DZD`,
              {
                x: 183,
                y: yOthers,
                size: 10,
                font: helveticaFont3,
                color: rgb(0, 0, 0),
              },
            );

            DDFthirdPage.drawText(`${item.quantity}`, {
              x: 140,
              y: yOthers,
              size: 10,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            });

            const truncatedSellingPrice =
              Math.trunc(item.sellingPrice * 100) / 100;
            DDFthirdPage.drawText(
              `${this.addSeparation(truncatedSellingPrice)} DZD`,
              {
                x: 40,
                y: yOthers,
                size: 10,
                font: helveticaFont3,
                color: rgb(0, 0, 0),
              },
            );

            yOthers = yOthers - 21;
          });
        }
      } else {
        console.log(">=16");

        //4th Page
        let yName = 703;
        let yOthers = 680;

        let yName4th = 768;
        let yOthers4th = 745;

        let firstItemsPart: OrderItemModel[] = this.order.orderItems.slice(
          0,
          15,
        );
        let secondItemsPart: OrderItemModel[] = this.order.orderItems.slice(15);

        firstItemsPart.forEach((item) => {
          let nameSplited = this.capitalizeWords(
            item.configurationTO.name.replace(",", " "),
          ).split(" ");
          let firstLine: string = "";
          let secondLine: string = "";
          let thirdLine: string = "";
          if (String(nameSplited.slice(0, 4)).replace(/,/g, " ").length < 28) {
            firstLine = String(nameSplited.slice(0, 5)).replace(/,/g, " ");
            secondLine = String(nameSplited.slice(5, 9)).replace(/,/g, " ");
            thirdLine = String(nameSplited.slice(9)).replace(/,/g, " ");
          } else {
            firstLine = String(nameSplited.slice(0, 4)).replace(/,/g, " ");
            secondLine = String(nameSplited.slice(4, 8)).replace(/,/g, " ");
            thirdLine = String(nameSplited.slice(8)).replace(/,/g, " ");
          }

          DDFthirdPage.drawText(`${firstLine}`, {
            x: 365,
            y: yName,
            size: 9.5,
            font: helveticaFont3,
            color: rgb(0, 0, 0),
          });

          yName = yName - 14.275;

          DDFthirdPage.drawText(`${secondLine}`, {
            x: 365,
            y: yName,
            size: 10,
            font: helveticaFont3,
            color: rgb(0, 0, 0),
          });

          yName = yName - 14.275;

          DDFthirdPage.drawText(`${thirdLine}`, {
            x: 365,
            y: yName,
            size: 10,
            font: helveticaFont3,
            color: rgb(0, 0, 0),
          });

          yName = yName - 14.275;

          const truncatedConfigPrice2 =
            Math.trunc((item.configurationTO.price / 1.19) * 100) / 100;
          DDFthirdPage.drawText(
            `${this.addSeparation(truncatedConfigPrice2)} DZD`,
            {
              x: 183,
              y: yOthers,
              size: 10,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            },
          );

          DDFthirdPage.drawText(`${item.quantity}`, {
            x: 140,
            y: yOthers,
            size: 10,
            font: helveticaFont3,
            color: rgb(0, 0, 0),
          });

          const truncatedSellingPrice2 =
            Math.trunc((item.sellingPrice / 1.19) * 100) / 100;
          DDFthirdPage.drawText(
            `${this.addSeparation(truncatedSellingPrice2)} DZD`,
            {
              x: 40,
              y: yOthers,
              size: 10,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            },
          );

          yOthers = yOthers - 43;
        });
        secondItemsPart.forEach((item) => {
          let nameSplited = this.capitalizeWords(
            item.configurationTO.name.replace(",", " "),
          ).split(" ");
          let firstLine: string = "";
          let secondLine: string = "";
          let thirdLine: string = "";
          if (String(nameSplited.slice(0, 4)).replace(/,/g, " ").length < 28) {
            firstLine = String(nameSplited.slice(0, 5)).replace(/,/g, " ");
            secondLine = String(nameSplited.slice(5, 9)).replace(/,/g, " ");
            thirdLine = String(nameSplited.slice(9)).replace(/,/g, " ");
          } else {
            firstLine = String(nameSplited.slice(0, 4)).replace(/,/g, " ");
            secondLine = String(nameSplited.slice(4, 8)).replace(/,/g, " ");
            thirdLine = String(nameSplited.slice(8)).replace(/,/g, " ");
          }

          DDFFourthPage.drawText(`${firstLine}`, {
            x: 365,
            y: yName4th,
            size: 9.5,
            font: helveticaFont3,
            color: rgb(0, 0, 0),
          });

          yName4th = yName4th - 14.275;

          DDFFourthPage.drawText(`${secondLine}`, {
            x: 365,
            y: yName4th,
            size: 10,
            font: helveticaFont3,
            color: rgb(0, 0, 0),
          });

          yName4th = yName4th - 14.275;

          DDFFourthPage.drawText(`${thirdLine}`, {
            x: 365,
            y: yName4th,
            size: 10,
            font: helveticaFont3,
            color: rgb(0, 0, 0),
          });

          yName4th = yName4th - 14.275;

          // DDFFourthPage.drawText(`${item.stockDepotId ? this.getStockNameByStockId(item.stockDepotId) : 'Stock EK'}`, {
          // x: 280,
          // y: yTable,
          // size: 10,
          // font: helveticaFont3,
          // color: rgb(0, 0, 0),
          // })

          const truncatedConfigPrice3 =
            Math.trunc((item.configurationTO.price / 1.19) * 100) / 100;
          DDFFourthPage.drawText(
            `${this.addSeparation(truncatedConfigPrice3)} DZD`,
            {
              x: 183,
              y: yOthers4th,
              size: 10,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            },
          );

          DDFFourthPage.drawText(`${item.quantity}`, {
            x: 140,
            y: yOthers4th,
            size: 10,
            font: helveticaFont3,
            color: rgb(0, 0, 0),
          });

          const truncatedSellingPrice3 =
            Math.trunc((item.sellingPrice / 1.19) * 100) / 100;
          DDFFourthPage.drawText(
            `${this.addSeparation(truncatedSellingPrice3)} DZD`,
            {
              x: 40,
              y: yOthers4th,
              size: 10,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            },
          );

          yOthers4th = yOthers4th - 43;
        });
      }

      let categoriess = Array.from(new Set(this.categoriess));

      const numberOfUniqueItems: number = this.order?.orderItems?.length;

      if (numberOfUniqueItems <= 3) {
        console.log("<=3");
        if (categoriess?.length <= 3) {
          console.log("<3");

          const firstLineCategories = categoriess?.join(", "); // Join the first four categories with commas
          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");
          context!.font = `${10}px ${helveticaFont3}`;

          const firstLineTextWidth =
            context!.measureText(firstLineCategories).width;
          const adjustedXFirstLine = 190 - firstLineTextWidth / 2;
          DDFthirdPage.drawText(
            firstLineCategories ? firstLineCategories : "",
            {
              x: adjustedXFirstLine,
              y: 462,
              size: 9,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            },
          );
        } else {
          console.log(">=3");
          const firstLineCategories = categoriess?.slice(0, 3).join("+ "); // Join the first four categories with commas
          const remainingCategories = categoriess?.slice(3).join("+ "); // Join the remaining categories with commas

          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");
          context!.font = `${10}px ${helveticaFont3}`;

          const firstLineTextWidth =
            context!.measureText(firstLineCategories).width;
          const secondLineTextWidth =
            context!.measureText(remainingCategories).width;

          const adjustedXFirstLine = 190 - firstLineTextWidth / 2;
          const adjustedXSecondLine = 180 - secondLineTextWidth / 2;

          DDFthirdPage.drawText(
            firstLineCategories ? firstLineCategories : "",
            {
              x: adjustedXFirstLine,
              y: 462,
              size: 9,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            },
          );
          DDFthirdPage.drawText(
            remainingCategories ? remainingCategories : "",
            {
              x: adjustedXSecondLine,
              y: 452,
              size: 9,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            },
          );
        }

        DDFthirdPage.drawText(
          `${
            this.credit?.total
              ? this.addSeparation(Math.trunc(100 * this.credit?.total) / 100)
              : ""
          }`,
          {
            x: 435,
            y: 435,
            size: 10,
            font: helveticaFont3,
            color: rgb(0, 0, 0),
          },
        );
        DDFthirdPage.drawText(`دج`, {
          x: 420,
          y: 435,
          size: 10,
          font: arabicFont3,
          color: rgb(0, 0, 0),
        });

        let numberOfMonths = this.order?.numberOfMonths;

        DDFthirdPage.drawText(`${numberOfMonths ? numberOfMonths : ""}`, {
          x: 300,
          y: 435,
          size: 11,
          font: helveticaFont3,
          color: rgb(0, 0, 0),
        });
        DDFthirdPage.drawText(`شهر`, {
          x: 270,
          y: 435,
          size: 11,
          font: arabicFont3,
          color: rgb(0, 0, 0),
        });

        DDFthirdPage.drawText(
          `${this.order.pointOfSaleTo?.posCommune ? this.order.pointOfSaleTo?.posCommune : ""}`,
          {
            x: 400,
            y: 145,
            size: 13,
            font: helveticaFont3,
            color: rgb(0, 0, 0),
          },
        );

        DDFthirdPage.drawText(
          `${this.order.createdAt ? this.datepipe.transform(new Date(this.order.createdAt), "yyyy/MM/dd") : ""}`,
          {
            x: 180,
            y: 145,
            size: 13,
            font: helveticaFont3,
            color: rgb(0, 0, 0),
          },
        );
      } else {
        if (numberOfUniqueItems < 6) {
          console.log("<6");
          if (categoriess?.length <= 3) {
            console.log("<3");

            const firstLineCategories = categoriess?.join(", "); // Join the first four categories with commas
            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            context!.font = `${10}px ${helveticaFont3}`;

            const firstLineTextWidth =
              context!.measureText(firstLineCategories).width;
            const adjustedXFirstLine = 190 - firstLineTextWidth / 2;
            DDFthirdPage.drawText(
              firstLineCategories ? firstLineCategories : "",
              {
                x: adjustedXFirstLine,
                y: 452,
                size: 9,
                font: helveticaFont3,
                color: rgb(0, 0, 0),
              },
            );
          } else {
            console.log(">=3");
            const firstLineCategories = categoriess?.slice(0, 3).join("+ "); // Join the first four categories with commas
            const remainingCategories = categoriess?.slice(3).join("+ "); // Join the remaining categories with commas

            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            context!.font = `${10}px ${helveticaFont3}`;

            const firstLineTextWidth =
              context!.measureText(firstLineCategories).width;
            const secondLineTextWidth =
              context!.measureText(remainingCategories).width;

            const adjustedXFirstLine = 190 - firstLineTextWidth / 2;
            const adjustedXSecondLine = 180 - secondLineTextWidth / 2;

            DDFthirdPage.drawText(
              firstLineCategories ? firstLineCategories : "",
              {
                x: adjustedXFirstLine,
                y: 452,
                size: 9,
                font: helveticaFont3,
                color: rgb(0, 0, 0),
              },
            );
            DDFthirdPage.drawText(
              remainingCategories ? remainingCategories : "",
              {
                x: adjustedXSecondLine,
                y: 442,
                size: 9,
                font: helveticaFont3,
                color: rgb(0, 0, 0),
              },
            );
          }

          DDFthirdPage.drawText(
            `${
              this.credit?.total
                ? this.addSeparation(Math.trunc(100 * this.credit?.total) / 100)
                : ""
            }`,
            {
              x: 435,
              y: 425,
              size: 10,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            },
          );
          DDFthirdPage.drawText(`دج`, {
            x: 420,
            y: 425,
            size: 10,
            font: arabicFont3,
            color: rgb(0, 0, 0),
          });

          let numberOfMonths = this.order?.numberOfMonths;

          DDFthirdPage.drawText(`${numberOfMonths ? numberOfMonths : ""}`, {
            x: 300,
            y: 425,
            size: 11,
            font: helveticaFont3,
            color: rgb(0, 0, 0),
          });
          DDFthirdPage.drawText(`شهر`, {
            x: 270,
            y: 425,
            size: 11,
            font: arabicFont3,
            color: rgb(0, 0, 0),
          });

          DDFthirdPage.drawText(
            `${this.order.pointOfSaleTo?.posCommune ? this.order.pointOfSaleTo?.posCommune : ""}`,
            {
              x: 400,
              y: 108,
              size: 13,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            },
          );

          DDFthirdPage.drawText(
            `${this.order.createdAt ? this.datepipe.transform(new Date(this.order.createdAt), "yyyy/MM/dd") : ""}`,
            {
              x: 180,
              y: 108,
              size: 13,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            },
          );
        } else if (numberOfUniqueItems >= 6 && numberOfUniqueItems < 11) {
          console.log(">= 6 && < 11");
          if (categoriess?.length <= 3) {
            console.log("<3");
            const firstLineCategories = categoriess?.join(", "); // Join the first four categories with commas
            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            context!.font = `${10}px ${helveticaFont3}`;

            const firstLineTextWidth =
              context!.measureText(firstLineCategories).width;
            const adjustedXFirstLine = 190 - firstLineTextWidth / 2;
            DDFthirdPage.drawText(
              firstLineCategories ? firstLineCategories : "",
              {
                x: adjustedXFirstLine,
                y: 345,
                size: 9,
                font: helveticaFont3,
                color: rgb(0, 0, 0),
              },
            );
          } else {
            console.log(">3");

            const firstLineCategories = categoriess?.slice(0, 3).join("+ "); // Join the first four categories with commas
            const remainingCategories = categoriess?.slice(3).join("+ "); // Join the remaining categories with commas

            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            context!.font = `${10}px ${helveticaFont3}`;

            const firstLineTextWidth =
              context!.measureText(firstLineCategories).width;
            const secondLineTextWidth =
              context!.measureText(remainingCategories).width;

            const adjustedXFirstLine = 190 - firstLineTextWidth / 2;
            const adjustedXSecondLine = 180 - secondLineTextWidth / 2;

            DDFthirdPage.drawText(
              firstLineCategories ? firstLineCategories : "",
              {
                x: adjustedXFirstLine,
                y: 345,
                size: 9,
                font: helveticaFont3,
                color: rgb(0, 0, 0),
              },
            );
            DDFthirdPage.drawText(
              remainingCategories ? remainingCategories : "",
              {
                x: adjustedXSecondLine,
                y: 338,
                size: 9,
                font: helveticaFont3,
                color: rgb(0, 0, 0),
              },
            );
          }

          DDFthirdPage.drawText(
            `${
              this.credit?.total
                ? this.addSeparation(Math.round(100 * this.credit?.total) / 100)
                : ""
            }`,
            {
              x: 435,
              y: 318,
              size: 10,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            },
          );
          DDFthirdPage.drawText(`دج`, {
            x: 420,
            y: 318,
            size: 10,
            font: arabicFont3,
            color: rgb(0, 0, 0),
          });

          let numberOfMonths = this.order?.numberOfMonths;
          /* switch (this.order?.numberOfMonths) {
                              case 'ONE_YEARS': {
                                numberOfMonths = 12;
                                break;
                              }
                              case 'TWO_YEARS': {
                                numberOfMonths = 24;
                                break;
                              }
                              case 'THREE_YEARS': {
                                numberOfMonths = 36;
                                break;
                              }
                            } */

          DDFthirdPage.drawText(`${numberOfMonths ? numberOfMonths : ""}`, {
            x: 300,
            y: 318,
            size: 11,
            font: helveticaFont3,
            color: rgb(0, 0, 0),
          });

          DDFthirdPage.drawText(`شهر`, {
            x: 270,
            y: 318,
            size: 11,
            font: arabicFont3,
            color: rgb(0, 0, 0),
          });

          DDFthirdPage.drawText(
            `${this.order.pointOfSaleTo?.posCommune ? this.order.pointOfSaleTo?.posCommune : ""}`,
            {
              x: 400,
              y: 65,
              size: 13,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            },
          );

          DDFthirdPage.drawText(
            `${
              this.order.createdAt
                ? this.datepipe.transform(
                    new Date(this.order.createdAt),
                    "yyyy/MM/dd",
                  )
                : ""
            }`,
            {
              x: 180,
              y: 65,
              size: 13,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            },
          );

          DDFthirdPage.drawText(
            `${this.folder?.requestNumber ? this.folder?.requestNumber : ""}`,
            {
              x: 245,
              y: 810,
              size: 12,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            },
          );
        } else if (numberOfUniqueItems >= 11 && numberOfUniqueItems < 16) {
          console.log(">= 11 ");
          if (categoriess?.length <= 3) {
            const firstLineCategories = categoriess?.join(", "); // Join the first four categories with commas
            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            context!.font = `${10}px ${helveticaFont3}`;

            const firstLineTextWidth =
              context!.measureText(firstLineCategories).width;
            const adjustedXFirstLine = 190 - firstLineTextWidth / 2;
            DDFthirdPage.drawText(
              firstLineCategories ? firstLineCategories : "",
              {
                x: adjustedXFirstLine,
                y: 238,
                size: 9,
                font: helveticaFont3,
                color: rgb(0, 0, 0),
              },
            );
          } else {
            const firstLineCategories = categoriess?.slice(0, 3).join(","); // Join the first four categories with commas
            const remainingCategories = categoriess?.slice(3).join(","); // Join the remaining categories with commas

            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            context!.font = `${10}px ${helveticaFont3}`;

            const firstLineTextWidth =
              context!.measureText(firstLineCategories).width;
            const secondLineTextWidth =
              context!.measureText(remainingCategories).width;

            const adjustedXFirstLine = 190 - firstLineTextWidth / 2;
            const adjustedXSecondLine = 180 - secondLineTextWidth / 2;

            DDFthirdPage.drawText(
              firstLineCategories ? firstLineCategories : "",
              {
                x: adjustedXFirstLine,
                y: 238,
                size: 9,
                font: helveticaFont3,
                color: rgb(0, 0, 0),
              },
            );
            DDFthirdPage.drawText(
              remainingCategories ? remainingCategories : "",
              {
                x: adjustedXSecondLine,
                y: 222,
                size: 9,
                font: helveticaFont3,
                color: rgb(0, 0, 0),
              },
            );
          }

          DDFthirdPage.drawText(
            `${
              this.credit?.total
                ? this.addSeparation(Math.round(100 * this.credit?.total) / 100)
                : ""
            }`,
            {
              x: 435,
              y: 212,
              size: 10,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            },
          );
          DDFthirdPage.drawText(`دج`, {
            x: 420,
            y: 212,
            size: 10,
            font: arabicFont3,
            color: rgb(0, 0, 0),
          });

          let numberOfMonths = this.order?.numberOfMonths;
          /* switch (this.order?.numberOfMonths) {
                              case 'ONE_YEARS': {
                                numberOfMonths = 12;
                                break;
                              }
                              case 'TWO_YEARS': {
                                numberOfMonths = 24;
                                break;
                              }
                              case 'THREE_YEARS': {
                                numberOfMonths = 36;
                                break;
                              }
                            } */

          DDFthirdPage.drawText(`${numberOfMonths ? numberOfMonths : ""}`, {
            x: 300,
            y: 212,
            size: 11,
            font: helveticaFont3,
            color: rgb(0, 0, 0),
          });
          DDFthirdPage.drawText(`شهر`, {
            x: 270,
            y: 212,
            size: 11,
            font: arabicFont3,
            color: rgb(0, 0, 0),
          });

          DDFFourthPage.drawText(
            `${this.order.pointOfSaleTo?.posCommune ? this.order.pointOfSaleTo?.posCommune : ""}`,
            {
              x: 400,
              y: 636,
              size: 13,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            },
          );

          DDFFourthPage.drawText(
            `${this.order.createdAt ? this.datepipe.transform(new Date(this.order.createdAt), "yyyy/MM/dd") : ""}`,
            {
              x: 180,
              y: 636,
              size: 13,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            },
          );

          DDFFourthPage.drawText(
            `${this.folder?.requestNumber ? this.folder?.requestNumber : ""}`,
            {
              x: 245,
              y: 810,
              size: 12,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            },
          );
        } else if (numberOfUniqueItems >= 16 && numberOfUniqueItems < 21) {
          if (categoriess?.length <= 3) {
            const firstLineCategories = categoriess?.join(", "); // Join the first four categories with commas
            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            context!.font = `${10}px ${helveticaFont3}`;

            const firstLineTextWidth =
              context!.measureText(firstLineCategories).width;
            const adjustedXFirstLine = 190 - firstLineTextWidth / 2;
            DDFFourthPage.drawText(
              firstLineCategories ? firstLineCategories : "",
              {
                x: adjustedXFirstLine,
                y: 399,
                size: 9,
                font: helveticaFont3,
                color: rgb(0, 0, 0),
              },
            );
          } else {
            const firstLineCategories = categoriess?.slice(0, 3).join("+ "); // Join the first four categories with commas
            const remainingCategories = categoriess?.slice(3).join("+ "); // Join the remaining categories with commas

            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            context!.font = `${10}px ${helveticaFont3}`;

            const firstLineTextWidth =
              context!.measureText(firstLineCategories).width;
            const secondLineTextWidth =
              context!.measureText(remainingCategories).width;

            const adjustedXFirstLine = 190 - firstLineTextWidth / 2;
            const adjustedXSecondLine = 180 - secondLineTextWidth / 2;

            DDFFourthPage.drawText(
              firstLineCategories ? firstLineCategories : "",
              {
                x: adjustedXFirstLine,
                y: 404,
                size: 9,
                font: helveticaFont3,
                color: rgb(0, 0, 0),
              },
            );
            DDFFourthPage.drawText(
              remainingCategories ? remainingCategories : "",
              {
                x: adjustedXSecondLine,
                y: 386,
                size: 9,
                font: helveticaFont3,
                color: rgb(0, 0, 0),
              },
            );
          }

          DDFFourthPage.drawText(
            `${
              this.credit?.total
                ? this.addSeparation(Math.round(100 * this.credit?.total) / 100)
                : ""
            }`,
            {
              x: 435,
              y: 370,
              size: 10,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            },
          );
          DDFFourthPage.drawText(`دج`, {
            x: 420,
            y: 370,
            size: 10,
            font: arabicFont3,
            color: rgb(0, 0, 0),
          });

          let numberOfMonths = this.order?.numberOfMonths;
          /* switch (this.order?.numberOfMonths) {
                              case 'ONE_YEARS': {
                                numberOfMonths = 12;
                                break;
                              }
                              case 'TWO_YEARS': {
                                numberOfMonths = 24;
                                break;
                              }
                              case 'THREE_YEARS': {
                                numberOfMonths = 36;
                                break;
                              }
                            } */

          DDFFourthPage.drawText(`${numberOfMonths ? numberOfMonths : ""}`, {
            x: 300,
            y: 370,
            size: 11,
            font: helveticaFont3,
            color: rgb(0, 0, 0),
          });
          DDFFourthPage.drawText(`شهر`, {
            x: 270,
            y: 370,
            size: 11,
            font: arabicFont3,
            color: rgb(0, 0, 0),
          });

          DDFFourthPage.drawText(
            `${this.order.pointOfSaleTo?.posCommune ? this.order.pointOfSaleTo?.posCommune : ""}`,
            {
              x: 400,
              y: 103,
              size: 13,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            },
          );

          DDFFourthPage.drawText(
            `${this.order.createdAt ? this.datepipe.transform(new Date(this.order.createdAt), "yyyy/MM/dd") : ""}`,
            {
              x: 180,
              y: 103,
              size: 13,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            },
          );

          DDFFourthPage.drawText(
            `${this.folder?.requestNumber ? this.folder?.requestNumber : ""}`,
            {
              x: 245,
              y: 810,
              size: 12,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            },
          );
        } else if (numberOfUniqueItems >= 21) {
          DDFFourthPage.drawText(
            `${this.folder?.requestNumber ? this.folder?.requestNumber : ""}`,
            {
              x: 245,
              y: 810,
              size: 12,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            },
          );

          if (categoriess?.length <= 3) {
            const firstLineCategories = categoriess?.join(", "); // Join the first four categories with commas
            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            context!.font = `${10}px ${helveticaFont3}`;

            const firstLineTextWidth =
              context!.measureText(firstLineCategories).width;
            const adjustedXFirstLine = 190 - firstLineTextWidth / 2;
            DDFFourthPage.drawText(
              firstLineCategories ? firstLineCategories : "",
              {
                x: adjustedXFirstLine,
                y: 201.5,
                size: 9,
                font: helveticaFont3,
                color: rgb(0, 0, 0),
              },
            );
          } else {
            const firstLineCategories = categoriess?.slice(0, 3).join("+ "); // Join the first four categories with commas
            const remainingCategories = categoriess?.slice(3).join("+ "); // Join the remaining categories with commas

            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            context!.font = `${10}px ${helveticaFont3}`;

            const firstLineTextWidth =
              context!.measureText(firstLineCategories).width;
            const secondLineTextWidth =
              context!.measureText(remainingCategories).width;

            const adjustedXFirstLine = 190 - firstLineTextWidth / 2;
            const adjustedXSecondLine = 180 - secondLineTextWidth / 2;

            DDFFourthPage.drawText(
              firstLineCategories ? firstLineCategories : "",
              {
                x: adjustedXFirstLine,
                y: 206.5,
                size: 9,
                font: helveticaFont3,
                color: rgb(0, 0, 0),
              },
            );
            DDFFourthPage.drawText(
              remainingCategories ? remainingCategories : "",
              {
                x: adjustedXSecondLine,
                y: 188.5,
                size: 9,
                font: helveticaFont3,
                color: rgb(0, 0, 0),
              },
            );
          }

          DDFFourthPage.drawText(
            `${
              this.credit?.total
                ? this.addSeparation(Math.round(100 * this.credit?.total) / 100)
                : ""
            }`,
            {
              x: 435,
              y: 250,
              size: 10,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            },
          );
          DDFFourthPage.drawText(`دج`, {
            x: 420,
            y: 250,
            size: 10,
            font: arabicFont3,
            color: rgb(0, 0, 0),
          });

          let numberOfMonths = this.order?.numberOfMonths;
          /* switch (this.order?.numberOfMonths) {
                              case 'ONE_YEARS': {
                                numberOfMonths = 12;
                                break;
                              }
                              case 'TWO_YEARS': {
                                numberOfMonths = 24;
                                break;
                              }
                              case 'THREE_YEARS': {
                                numberOfMonths = 36;
                                break;
                              }
                            } */

          DDFFourthPage.drawText(`${numberOfMonths ? numberOfMonths : ""}`, {
            x: 300,
            y: 172.5,
            size: 11,
            font: helveticaFont3,
            color: rgb(0, 0, 0),
          });
          DDFFourthPage.drawText(`شهر`, {
            x: 270,
            y: 172.5,
            size: 11,
            font: arabicFont3,
            color: rgb(0, 0, 0),
          });

          DDFFifthPage.drawText(
            `${this.order.pointOfSaleTo?.posCommune ? this.order.pointOfSaleTo?.posCommune : ""}`,
            {
              x: 400,
              y: 652,
              size: 13,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            },
          );
          DDFFifthPage.drawText(
            `${this.order.createdAt ? this.datepipe.transform(new Date(this.order.createdAt), "yyyy/MM/dd") : ""}`,
            {
              x: 180,
              y: 652,
              size: 13,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            },
          );

          DDFFifthPage.drawText(
            `${this.folder?.requestNumber ? this.folder?.requestNumber : ""}`,
            {
              x: 245,
              y: 810,
              size: 12,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            },
          );
        }
      }

      //Demande de financement
      const pdfBytes3 = await DDF.save();
      this.saveByteArray(
        `Demande de financement - ${this.folder?.requestNumber ? this.folder?.requestNumber : ""}.pdf`,
        pdfBytes3,
      );
    }

    // Fiche De Signature
    if (this.ficheDeSignature) {
      const ficheDeSignature = await fetch(this.ficheDeSignature).then((res) =>
        res.arrayBuffer(),
      );
      const FDS = await PDFDocument.load(ficheDeSignature);
      FDS.registerFontkit(fontkit);
      const arabicFont4 = await FDS.embedFont(fontBytes);
      const helveticaFont4 = await FDS.embedFont(StandardFonts.HelveticaBold);

      const FDSpages = FDS.getPages();
      const FDSfirstPage = FDSpages[0];

      FDSfirstPage.drawText(
        `${this.folder?.requestNumber ? this.folder?.requestNumber : ""}`,
        {
          x: 17,
          y: 740,
          size: 15,
          font: helveticaFont4,
          color: rgb(0, 0, 0),
        },
      );

      var x = 120;

      // FDSfirstPage.drawText(
      //   `${this.information?.financialSituation?.accountNumber}`,
      //   {
      //     x: x - 10,
      //     y: 625,
      //     size: 12,
      //     font: helveticaFont4,
      //     color: rgb(0, 0, 0),
      //   }
      // );

      FDSfirstPage.drawText(
        `${
          this.information?.personnelInformation?.fistNameEnArab
            ? this.information?.personnelInformation?.fistNameEnArab!
            : ""
        }   ${
          this.information?.personnelInformation?.lastNameEnArab
            ? this.information?.personnelInformation?.lastNameEnArab
            : ""
        }`,
        {
          x: this.getX(
            x + 20,
            this.information?.personnelInformation?.lastNameEnArab! +
              this.information?.personnelInformation?.fistNameEnArab!,
            arabicFont4,
            10,
          ),
          y: 656,
          size: 12,
          font: arabicFont4,
          color: rgb(0, 0, 0),
        },
      );

      var x2 = 150;

      if (this.information?.personnelSituation?.personnelSituationAddress) {
        const adress = this.invertNumbers(
          this.information?.personnelSituation?.personnelSituationAddress!,
        )!.split(/\s+/);
        var firstPart =
          this.numberTrim(adress[0]) +
          " " +
          this.numberTrim(adress[1]) +
          " " +
          this.numberTrim(adress[2]);
        secondPart = String(adress.slice(3).join(" "));
        if (firstPart.length < 14) {
          firstPart =
            this.numberTrim(adress[0]) +
            " " +
            this.numberTrim(adress[1]) +
            " " +
            this.numberTrim(adress[2]) +
            " " +
            this.numberTrim(adress[3]);
          secondPart = String(adress.slice(4).join(" "));
        }

        let firstPartArray = firstPart.split(" ");
        firstPart = firstPartArray
          .filter((word) => word !== "undefined")
          .join(" ");
        let secondPartArray = secondPart.split(" ");
        secondPart = secondPartArray
          .filter((word) => word !== "undefined")
          .join(" ");

        FDSfirstPage.drawText(`${firstPart}`, {
          x: this.getX(x2 + 50, firstPart, arabicFont4, 12),
          y: 595,
          size: 12,
          font: arabicFont4,
          color: rgb(0, 0, 0),
        });
        FDSfirstPage.drawText(`${secondPart}`, {
          x: this.getX(x2 + 80, secondPart, arabicFont4, 12),
          y: 580,
          size: 12,
          font: arabicFont4,
          color: rgb(0, 0, 0),
        });
      }

      // FDSfirstPage.drawText(
      //   `${this.order.pointOfSaleTo?.posCommune ? this.order.pointOfSaleTo?.posCommune : ''}`,
      //   {
      //     x: x + 102,
      //     y: 540.5,
      //     size: 11,
      //     font: helveticaFont4,
      //     color: rgb(0, 0, 0),
      //   }
      // );

      FDSfirstPage.drawText(
        `${this.order.createdAt ? this.datepipe.transform(new Date(this.order.createdAt), "dd/MM/yyyy") : ""}`,
        {
          x: x + 158,
          y: 575,
          size: 11,
          font: helveticaFont4,
          color: rgb(0, 0, 0),
        },
      );

      // if(image) {
      //   FDSfirstPage.drawImage(image, {
      //     x: 465,
      //     y: 530,
      //     width: 92,
      //     height: 88,
      //   });
      // }

      //Fiche de signature
      const pdfBytes4 = await FDS.save();
      this.saveByteArray(
        `Fiche de signature - ${this.folder?.requestNumber ? this.folder?.requestNumber : ""}.pdf`,
        pdfBytes4,
      );
    }

    // Engagement De Solde
    if (this.engagementDeSolde) {
      //Engagement
      const engagementDeSolde = await fetch(this.engagementDeSolde).then(
        (res) => res.arrayBuffer(),
      );
      const EDS = await PDFDocument.load(engagementDeSolde);
      EDS.registerFontkit(fontkit);
      const arabicFont5 = await EDS.embedFont(fontBytes);
      const helveticaFont5 = await EDS.embedFont(StandardFonts.HelveticaBold);

      const EDSpages = EDS.getPages();
      const EDSfirstPage = EDSpages[0];

      EDSfirstPage.drawText(
        `${this.folder?.requestNumber ? this.folder?.requestNumber : ""}`,
        {
          x: 43,
          y: 790,
          size: 14,
          font: helveticaFont5,
          color: rgb(0, 0, 0),
        },
      );

      EDSfirstPage.drawText(
        `${
          this.information?.personnelInformation?.fistNameEnArab
            ? this.information?.personnelInformation?.fistNameEnArab!
            : ""
        }   ${
          this.information?.personnelInformation?.lastNameEnArab
            ? this.information?.personnelInformation?.lastNameEnArab
            : ""
        }`,
        {
          x: this.getX(
            390,
            this.information?.personnelInformation?.lastNameEnArab! +
              this.information?.personnelInformation?.fistNameEnArab!,
            arabicFont5,
            13,
          ),
          y: 673,
          size: 13,
          font: arabicFont5,
          color: rgb(0, 0, 0),
        },
      );

      EDSfirstPage.drawText(
        `${
          this.information?.personnelSituation?.personnelSituationAddress
            ? this.invertNumbers(
                this.information?.personnelSituation
                  ?.personnelSituationAddress!,
              )
            : ""
        }`,
        {
          x: this.getX(
            480,
            this.invertNumbers(
              this.information?.personnelSituation?.personnelSituationAddress!,
            )!,
            arabicFont5,
            13,
          ),
          y: 646,
          size: 13,
          font: arabicFont5,
          color: rgb(0, 0, 0),
        },
      );

      //cni or drivinglicense
      EDSfirstPage.drawText(
        `${
          this.information?.personnelInformation?.idCardNumber
            ? this.information?.personnelInformation?.idCardNumber
            : this.information?.personnelInformation?.driverLicenceNumber
              ? this.information?.personnelInformation?.driverLicenceNumber
              : ""
        }`,
        {
          x: 160,
          y: 620,
          size: 14,
          font: helveticaFont5,
          color: rgb(0, 0, 0),
        },
      );
      EDSfirstPage.drawText(
        `${
          this.information?.personnelInformation?.idCardNumber
            ? this.information?.personnelInformation?.deliveryDate
              ? this.information?.personnelInformation?.deliveryDate
              : ""
            : this.information?.personnelInformation?.driverLicenceIssuanceDate
              ? this.information?.personnelInformation
                  ?.driverLicenceIssuanceDate
              : ""
        }`,
        {
          x: 340,
          y: 592,
          size: 14,
          font: helveticaFont5,
          color: rgb(0, 0, 0),
        },
      );
      EDSfirstPage.drawText(
        `${
          this.information?.personnelInformation?.idCardNumber
            ? this.information?.personnelInformation?.deliveryDaira
            : this.information?.personnelInformation?.issuingAuthorityLatin
        }`,
        {
          x: 140,
          y: 592,
          size: 14,
          font: helveticaFont5,
          color: rgb(0, 0, 0),
        },
      );

      if (this.information?.financialSituation?.accountType === "CCP") {
        EDSfirstPage.drawText(
          `${this.information?.financialSituation?.accountNumber ? this.information?.financialSituation?.accountNumber : ""}`,
          {
            x: 280,
            y: 565,
            size: 14,
            font: helveticaFont5,
            color: rgb(0, 0, 0),
          },
        );
      }

      EDSfirstPage.drawText(
        `${this.order.pointOfSaleTo?.posCommune ? this.order.pointOfSaleTo?.posCommune : ""}`,
        {
          x: 230,
          y: 308,
          size: 13,
          font: helveticaFont5,
          color: rgb(0, 0, 0),
        },
      );
      EDSfirstPage.drawText(
        `${this.order.createdAt ? this.datepipe.transform(new Date(this.order.createdAt), "yyyy/MM/dd") : ""}`,
        {
          x: 90,
          y: 308,
          size: 13,
          font: helveticaFont5,
          color: rgb(0, 0, 0),
        },
      );

      //Engagement de maintien solde suffisant sous compte CCP
      const pdfBytes5 = await EDS.save();
      this.saveByteArray(
        `Engagement de maintien solde suffisant sous compte CCP - ${this.folder?.requestNumber ? this.folder?.requestNumber : ""}.pdf`,
        pdfBytes5,
      );
    }

    //FATCA
    if (this.fatca) {
      const fatca = await fetch(this.fatca).then((res) => res.arrayBuffer());
      const FATCA = await PDFDocument.load(fatca);
      FATCA.registerFontkit(fontkit);
      const arabicFont6 = await FATCA.embedFont(fontBytes);
      const helveticaFont6 = await FATCA.embedFont(StandardFonts.HelveticaBold);

      const FATCApages = FATCA.getPages();
      const FATCAfirstPage = FATCApages[0];
      const FATCAsecondPage = FATCApages[1];

      FATCAfirstPage.drawText(
        `${this.folder?.requestNumber ? this.folder?.requestNumber : ""}`,
        {
          x: 430,
          y: 780,
          size: 15,
          font: helveticaFont6,
          color: rgb(0, 0, 0),
        },
      );

      FATCAsecondPage.drawText(
        `${this.folder?.requestNumber ? this.folder?.requestNumber : ""}`,
        {
          x: 430,
          y: 780,
          size: 15,
          font: helveticaFont6,
          color: rgb(0, 0, 0),
        },
      );

      if (this.information?.personnelInformation?.gender) {
        FATCAfirstPage.drawText(`X`, {
          x:
            this.information?.personnelInformation?.gender === "Male"
              ? 225
              : 350,
          y: 438,
          size: 13,
          font: helveticaFont6,
          color: rgb(0, 0, 0),
        });
      }

      FATCAfirstPage.drawText(
        `${
          this.information?.personnelInformation?.fistNameEnArab
            ? this.information?.personnelInformation?.fistNameEnArab
            : ""
        }`,
        {
          x: 90,
          y: 410,
          size: 10,
          font: arabicFont6,
          color: rgb(0, 0, 0),
        },
      );
      FATCAfirstPage.drawText(
        `${
          this.information?.personnelInformation?.lastNameEnArab
            ? this.information?.personnelInformation?.lastNameEnArab
            : ""
        }`,
        {
          x: 180,
          y: 410,
          size: 10,
          font: arabicFont6,
          color: rgb(0, 0, 0),
        },
      );

      FATCAfirstPage.drawText(
        `${
          this.information?.personnelInformation?.birthDay
            ? this.information?.personnelInformation?.birthDay
            : ""
        }`,
        {
          x: 260,
          y: 410,
          size: 10,
          font: helveticaFont6,
          color: rgb(0, 0, 0),
        },
      );

      FATCAfirstPage.drawText(
        `${
          this.information?.personnelInformation?.placeOfBrithArabic
            ? this.information?.personnelInformation?.placeOfBrithArabic
            : ""
        }`,
        {
          x: 360,
          y: 410,
          size: 10,
          font: arabicFont6,
          color: rgb(0, 0, 0),
        },
      );

      FATCAfirstPage.drawText(`Algérienne`, {
        x: 110,
        y: 369,
        size: 10,
        font: helveticaFont6,
        color: rgb(0, 0, 0),
      });

      FATCAfirstPage.drawText(
        `${
          this.information?.personnelSituation?.personnelSituationAddress
            ? this.invertNumbers(
                this.information?.personnelSituation
                  ?.personnelSituationAddress!,
              )
            : ""
        }`,
        {
          x: 110,
          y: 328,
          size: 10,
          font: arabicFont6,
          color: rgb(0, 0, 0),
        },
      );
      FATCAfirstPage.drawText(
        `${
          this.information?.personnelSituation?.zipCode
            ? this.information?.personnelSituation.zipCode
            : ""
        }`,
        {
          x: 90,
          y: 298,
          size: 10,
          font: helveticaFont6,
          color: rgb(0, 0, 0),
        },
      );

      FATCAfirstPage.drawText(
        `${
          this.information?.personnelSituation?.personnelSituationCommune
            ? this.information?.personnelSituation?.personnelSituationCommune
            : ""
        }`,
        {
          x: 200,
          y: 298,
          size: 10,
          font: helveticaFont6,
          color: rgb(0, 0, 0),
        },
      );

      FATCAfirstPage.drawText(`Algérie`, {
        x: 340,
        y: 298,
        size: 10,
        font: helveticaFont6,
        color: rgb(0, 0, 0),
      });

      FATCAfirstPage.drawText(`${this.order?.phone ? this.order?.phone : ""}`, {
        x: 110,
        y: 225,
        size: 10,
        font: helveticaFont6,
        color: rgb(0, 0, 0),
      });
      FATCAfirstPage.drawText(`${this.client ? this.client?.email : ""}`, {
        x: 110,
        y: 196,
        size: 10,
        font: helveticaFont6,
        color: rgb(0, 0, 0),
      });

      FATCAfirstPage.drawText(`X`, {
        x: this.information?.personnelInformation?.greenCardDetail ? 250 : 300, //300
        y: 165,
        size: 10,
        font: helveticaFont6,
        color: rgb(0, 0, 0),
      });

      FATCAfirstPage.drawText(`X`, {
        x: 300,
        y: 145,
        size: 10,
        font: helveticaFont6,
        color: rgb(0, 0, 0),
      });

      FATCAsecondPage.drawText(`X`, {
        x: 280,
        y: 700,
        size: 13,
        font: helveticaFont6,
        color: rgb(0, 0, 0),
      });

      FATCAsecondPage.drawText(`X`, {
        x: 280,
        y: 625,
        size: 13,
        font: helveticaFont6,
        color: rgb(0, 0, 0),
      });

      FATCAsecondPage.drawText(`X`, {
        x: 280,
        y: 568,
        size: 13,
        font: helveticaFont6,
        color: rgb(0, 0, 0),
      });

      FATCAsecondPage.drawText(`X`, {
        x: 95,
        y: 283,
        size: 13,
        font: helveticaFont6,
        color: rgb(0, 0, 0),
      });

      FATCAsecondPage.drawText(
        `${this.order.pointOfSaleTo?.posCommune ? this.order.pointOfSaleTo?.posCommune : ""}`,
        {
          x: 140,
          y: 120,
          size: 10,
          font: helveticaFont6,
          color: rgb(0, 0, 0),
        },
      );

      FATCAsecondPage.drawText(
        `${this.order.createdAt ? this.datepipe.transform(new Date(this.order.createdAt), "dd/MM/yyyy") : ""}`,
        {
          x: 340,
          y: 120,
          size: 10,
          font: helveticaFont6,
          color: rgb(0, 0, 0),
        },
      );

      //FATCA
      const pdfBytes6 = await FATCA.save();
      this.saveByteArray(
        `FATCA - ${this.folder?.requestNumber ? this.folder?.requestNumber : ""}.pdf`,
        pdfBytes6,
      );
    }

    // Autorisation de consultation de la centrale des riques
    if (this.autorisationDeConsultation) {
      const autorisationDeConsultation = await fetch(
        this.autorisationDeConsultation,
      ).then((res) => res.arrayBuffer());
      const ACCR = await PDFDocument.load(autorisationDeConsultation);
      ACCR.registerFontkit(fontkit);
      const arabicFont7 = await ACCR.embedFont(fontBytes);
      const helveticaFont7 = await ACCR.embedFont(StandardFonts.HelveticaBold);

      const ACCRpages = ACCR.getPages();
      const ACCRfirstPage = ACCRpages[0];

      // requestNumber
      ACCRfirstPage.drawText(
        `${this.folder?.requestNumber ? this.folder?.requestNumber : ""}`,
        {
          x: 55,
          y: 790,
          size: 15,
          font: helveticaFont7,
          color: rgb(0, 0, 0),
        },
      );

      // fistNameEnArab / lastNameEnArab
      ACCRfirstPage.drawText(
        `${
          this.information?.personnelInformation?.fistNameEnArab
            ? this.information?.personnelInformation?.fistNameEnArab!
            : ""
        }   ${
          this.information?.personnelInformation?.lastNameEnArab
            ? this.information?.personnelInformation?.lastNameEnArab
            : ""
        }`,
        {
          x: this.getX(
            370,
            this.information?.personnelInformation?.lastNameEnArab! +
              this.information?.personnelInformation?.fistNameEnArab,
            arabicFont7,
            14,
          ),
          y: 650,
          size: 15,
          font: arabicFont7,
          color: rgb(0, 0, 0),
        },
      );

      // birthDay
      ACCRfirstPage.drawText(
        `${
          this.information?.personnelInformation?.birthDay
            ? this.information?.personnelInformation?.birthDay
            : ""
        }`,
        {
          x: 340,
          y: 590,
          size: 14,
          font: helveticaFont7,
          color: rgb(0, 0, 0),
        },
      );

      //placeOfBrithArabic
      ACCRfirstPage.drawText(
        `${
          this.information?.personnelInformation?.placeOfBrithArabic
            ? this.information?.personnelInformation?.placeOfBrithArabic
            : ""
        }`,
        {
          x: this.getX(
            230,
            this.information?.personnelInformation?.placeOfBrithArabic!,
            arabicFont7,
            14,
          ),
          y: 590,
          size: 14,
          font: arabicFont7,
          color: rgb(0, 0, 0),
        },
      );

      // personnelSituationAddress
      ACCRfirstPage.drawText(
        `${
          this.information?.personnelSituation?.personnelSituationAddress
            ? this.invertNumbers(
                this.information?.personnelSituation
                  ?.personnelSituationAddress!,
              )
            : ""
        }`,
        {
          x: this.getX(
            490,
            this.invertNumbers(
              this.information?.personnelSituation?.personnelSituationAddress!,
            )!,
            arabicFont7,
            14,
          ),
          y: 532,
          size: 14,
          font: arabicFont7,
          color: rgb(0, 0, 0),
        },
      );

      ACCRfirstPage.drawText(
        `${this.order.pointOfSaleTo?.posCommune ? this.order.pointOfSaleTo?.posCommune : ""}`,
        {
          x: 400,
          y: 365,
          size: 13,
          font: helveticaFont7,
          color: rgb(0, 0, 0),
        },
      );

      ACCRfirstPage.drawText(
        `${this.order.createdAt ? this.datepipe.transform(new Date(this.order.createdAt), "yyyy/MM/dd") : ""}`,
        {
          x: 260,
          y: 365,
          size: 13,
          font: helveticaFont7,
          color: rgb(0, 0, 0),
        },
      );

      //Autorisation de consultation de la centrale des risques
      const pdfBytes7 = await ACCR.save();
      this.saveByteArray(
        `Autorisation de consultation de la centrale des risques - ${this.folder?.requestNumber ? this.folder?.requestNumber : ""}.pdf`,
        pdfBytes7,
      );
    }

    //Annexe – protection des données
    if (this.annexProtectionData) {
      const annexProtectionData = await fetch(this.annexProtectionData, {
        cache: "no-store",
      }).then((res) => res.arrayBuffer());
      const APD = await PDFDocument.load(annexProtectionData);
      APD.registerFontkit(fontkit);

      const APDhelveticaFont = await APD.embedFont(StandardFonts.HelveticaBold);

      const APDpages = APD.getPages();
      const APDFirstPage = APDpages[0];
      const APDSecondPage = APDpages[1];
      const APDThirdPage = APDpages[2];

      // 1. Récupère les dimensions de la page
      const ADPWidth = APDFirstPage.getSize().width;

      const textAPDWidthX = APDhelveticaFont.widthOfTextAtSize(
        this.folder.requestNumber,
        14,
      );

      x = (ADPWidth - textAPDWidthX) / 2 + 5;

      // req number page 1
      APDFirstPage.drawText(
        `${this.folder?.requestNumber ? this.folder?.requestNumber : ""}`,
        {
          x: 28,
          y: 780,
          size: 12,
          font: APDhelveticaFont,
          color: rgb(0, 0, 0),
        },
      );

      // req number page 2
      APDSecondPage.drawText(
        `${this.folder?.requestNumber ? this.folder?.requestNumber : ""}`,
        {
          x: 28,
          y: 780,
          size: 12,
          font: APDhelveticaFont,
          color: rgb(0, 0, 0),
        },
      );

      // req number page 3
      APDThirdPage.drawText(
        `${this.folder?.requestNumber ? this.folder?.requestNumber : ""}`,
        {
          x: 28,
          y: 780,
          size: 12,
          font: APDhelveticaFont,
          color: rgb(0, 0, 0),
        },
      );

      // Annexe – protection des données
      const pdfBytes8 = await APD.save();
      this.saveByteArray(
        `Annexe – protection des données - ${this.folder?.requestNumber ? this.folder?.requestNumber : ""}.pdf`,
        pdfBytes8,
      );
    }

    this.downLoadFiles$.next(false);
  }

  numberTrim(string: string) {
    let words = /\d/.test(string);
    if (words) {
      return String(string.split(/\s+/).reverse()).trim();
    } else {
      return string;
    }
  }

  invertNumbers(input: string): string {
    return input?.replace(/\d+/g, (match) => {
      return match?.split("").reverse().join("");
    });
  }

  capitalizeWords(input: string): string {
    return input.replace(/\b\w+\b/g, (match) => {
      return match.charAt(0).toUpperCase() + match.slice(1).toLowerCase();
    });
  }

  saveByteArray(reportName: any, byte: any) {
    var blob = new Blob([byte], { type: "application/pdf" });
    var link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = reportName;
    link.click();
  }

  addSeparation(value: number): string {
    if (value) {
      const stringValue = value.toString();
      const separatedValue = stringValue.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      return separatedValue;
    } else {
      return "";
    }
  }

  getX(x: number, value: string, font: any, fontSize: number) {
    if (value) {
      const textWidth = font.widthOfTextAtSize(value, fontSize);
      const startX = x - textWidth;
      return startX;
    } else {
      return 0;
    }
  }

  formatNumber(num: number): string {
    const formattedNumber = num.toFixed(2);
    const parts = formattedNumber.split("." || ",");
    const integerPart = parts[0].padStart(7, "0");
    const decimalPart = parts[1];
    return `${integerPart},${decimalPart}`;
  }

  ngOnInit() {
    this.route.paramMap.subscribe((params: any) => {
      this.folderId = Number(params.get("idFolder"));
      this.orderId = Number(params.get("idOrder"));
    });

    const currentDate = new Date();

    currentDate.setDate(27);

    currentDate.setMonth(currentDate.getMonth() + 2);

    this.datePrelevement = currentDate.toLocaleDateString("en-GB"); // Format: dd-MM-yyyy

    this.orderSplitService.orderSplit$.subscribe((res) => {
      if (res) {
        this.order = res;

        this.orderSplitService.getCredit(res.id).subscribe((cr) => {
          this.credit = cr;
        });

        this.categoriess = [];

        res.orderItems.forEach((config) => {
          this.productsService
            .getById(config.configurationTO.productId)
            .subscribe((product) => {
              if (product) {
                this.categoryService
                  .getParentCategoryById(product.categoryId)
                  .subscribe((category) => {
                    if (category) {
                      this.categoriess.push(category);
                    }
                  });
              }
            });
        });
      }
    });

    this.route.paramMap.subscribe((params: any) => {
      this.folderId = Number(params.get("idFolder"));
    });
    this.documentService
      .getDocumentsByFolderId(this.folderId)
      .subscribe((res: any) => {
        this.bankDocuments$.next(
          res.body.filter(
            (document: DocumentModel) => document.documentsType === "BANK",
          ),
        );
      });

    this.stocksService.getAll().subscribe((res) => {
      this.stocks = res;
    });

    this.documentService
      .downloadDocuments("BANK_EMPTY", this.orderId)
      .subscribe({
        next: (res: any) => {
          let obj = res.body.find((o: any) => {
            switch (o.documentsTitle) {
              // Autorisation de prélèvement
              case "DIRECT_DEBIT_AUTHORIZATION": {
                this.autorisationDePrelevement = o.documentUrl;
                break;
              }
              // Autorisation de prélèvement bancaire
              case "BANK_DEBIT_AUTHORIZATION": {
                this.autorisationDePrelevementBancaire = o.documentUrl;
                break;
              }
              // Autorisation de consultation de la centrale des risques
              case "AUTHORIZATION_TO_CONSULT_THE_CREDIT_BUREAU": {
                this.autorisationDeConsultation = o.documentUrl;
                break;
              }
              // facta
              case "FACTA": {
                this.fatca = o.documentUrl;
                break;
              }
              // Fiche de signature
              case "SIGNATURE_SHEET": {
                this.ficheDeSignature = o.documentUrl;
                break;
              }
              // Demande de financement
              case "REQUEST_FOR_FINANCING": {
                this.demandeDeFinancement = o.documentUrl;
                break;
              }
              // Demande ouverture de compte
              case "ACCOUNT_OPENING_REQUEST": {
                this.demandeOuvertureCompteB = o.documentUrl;
                break;
              }
              // Engagement de maintien solde suffisant sous compte CCP
              case "COMMITMENT_TO_MAINTAIN_SUFFICIENT_BALANCE_UNDER_CCP_ACCOUNT": {
                this.engagementDeSolde = o.documentUrl;
                break;
              }
              // Annexe – protection des données
              case "ANNEX_PROTECTION_DATA": {
                this.annexProtectionData = o.documentUrl;
                break;
              }
            }
          });
        },
        error: () => {
          this.downLoadFiles$.next(false);
          const message = `Erreur lors du téléchargement des documents bancaires !`;
          this.layoutUtilsService.showActionNotification(
            message,
            MessageType.Delete,
            5000,
            true,
            true,
          );
        },
      });
  }

  reverseDigitsInText(text: string): string {
    if (!text) return "";

    return text
      .split(/(\d+)/) // split but keep numbers
      .map((token) => {
        // If token is all digits, reverse it
        if (/^\d+$/.test(token)) {
          return token.split("").reverse().join("");
        }
        return token;
      })
      .join("");
  }
}
